import Axios, {
  AxiosRequestConfig,
  AxiosRequestHeaders, AxiosResponseHeaders,
  AxiosInstance
} from 'axios';

import { BaseResponseInterface } from '@interface/public';

const domainPath = $ENV.isFormal // 域名
    ? { // 正式服
      api: 'https://api.galaxy-future.com/' // API
    }
    : { // 测试服
      api: 'http://172.16.148.206:9093/' // API
    },
  config: AxiosRequestConfig = { // 配置
    headers: {
      'Content-Type': 'application/json; charset=utf-8', // 发送数据类型
      Authorization: 'Bearer' // 授权
    },
    method: 'get',
    timeout: 10000,
    transformRequest: [
      function (data: any, header: AxiosRequestHeaders): string {
        console.log(`${ $Config.Console.log }请求：`, this.method, this.url, this.method === 'get' ? this.params : data);
        
        header.Authorization += ` ${ $Store.User().token }`;
        
        return JSON.stringify(data);
      }
    ],
    transformResponse: [
      function (data: string, header: AxiosResponseHeaders): BaseResponseInterface {
        const newData: BaseResponseInterface = JSON.parse(data);
        
        console.log(`${ $Config.Console.log }响应：`, this.method, this.url, newData);
        
        switch (newData.code) { // 特殊错误码处理
          case $Enum.CodeEnum.ErrorAuthReset: // 刷新会话
            newData.code = $Enum.CodeEnum.Normal;
            $RQ.RefreshToken();
            break;
          default:
            break;
        }
        
        if (newData.code === $Enum.CodeEnum.ErrorAuthFail ||
            newData.code === $Enum.CodeEnum.ErrorAuthExpired ||
            newData.code === $Enum.CodeEnum.ErrorNotExist) { // 会话过期
          $RQ.SSO.logout();
          $Application.Router.push($Enum.RouterEnum.SSOIndex);
        }
        
        newData.code !== $Enum.CodeEnum.Normal && // 请求报错
        newData.code !== $Enum.CodeEnum.UserCanceling &&
        $FN.Notification('error', {
          message: newData.message || newData.msg
        });
        
        return newData;
      }
    ]
  };

export const AxiosAPI: AxiosInstance = Axios.create(Object.assign({}, config, { // 平台
  baseURL: domainPath.api
}));
